/**
 * Libs
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Constants
 */
import { ProfileLaunchpadsSort } from 'src/features/common/explore/ducks/launchpads/launchpads.types';

interface ILocale {
    priceHighLow: string;
    priceLowHigh: string;
    latest: string;
    oldest: string;
}

export const useLaunchpadSortingOptions = () => {
    const { t } = useTranslation(['components']);

    const locale: ILocale = useMemo(
        () => ({
            ...t('exploreFilter.actions.sorting.mode', { returnObjects: true }),
        }),
        [t]
    );

    return useMemo(
        () => [
            { value: ProfileLaunchpadsSort.LATEST, label: locale.latest },
            { value: ProfileLaunchpadsSort.OLDEST, label: locale.oldest },
            { value: ProfileLaunchpadsSort.PRICE_TO_HIGH, label: locale.priceLowHigh },
            { value: ProfileLaunchpadsSort.PRICE_TO_LOW, label: locale.priceHighLow },
        ],
        [locale]
    );
};
